import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import styles from './index.module.scss';

const DecisionText = () => {
  return (
    <div className={styles.decisionText}>
      <ArrowDownwardIcon className={'mr-1'} />
      Decision made that impacted the treatment and plan of care:
    </div>
  );
};

export default DecisionText;
